export default __webpack_public_path__ + "static/media/tableau.d6d968eb.png";